import { create } from 'zustand'

import { rulesOf } from '../lib/rules'
import { socialStatus, updateConsent } from '../services/social'

/**
 * Whether the signed-in learner has accepted «قوانین طوطی» (R13,
 * `lib/rules.js`): read from `social_status` once per account and per app
 * open, not on every page — the gate sits in front of every app route.
 * `userId` ties the answer to the account it was read for, so a sign-out and
 * a different sign-in on the same device read it again.
 */
export const useRulesStore = create((set, get) => ({
  userId: null,
  phase: 'idle', // 'idle' | 'loading' | 'ready' | 'error'
  consentGiven: false,
  text: '',
  version: null,
  busy: false,
  failed: false,

  async load(userId) {
    if (!userId) return
    const current = get()
    if (current.userId === userId && current.phase !== 'idle' && current.phase !== 'error') return
    set({ userId, phase: 'loading', failed: false })
    try {
      const rules = rulesOf(await socialStatus())
      if (get().userId === userId) set({ ...rules, phase: 'ready' })
    } catch {
      if (get().userId === userId) set({ phase: 'error' })
    }
  },

  /**
   * «ادامه»: the server records the version it serves; the answer says
   * whether that took. A failed save keeps the rules on screen with a note —
   * it never counts as accepted, and never as a status that could not be read.
   */
  async accept() {
    if (get().busy) return
    set({ busy: true, failed: false })
    try {
      const rules = rulesOf(await updateConsent(true))
      set({ ...rules, phase: 'ready', busy: false })
    } catch {
      set({ busy: false, failed: true })
    }
  },

  reset() {
    set({ userId: null, phase: 'idle', consentGiven: false, text: '', version: null, busy: false, failed: false })
  },
}))
